import { redirect } from "@tanstack/react-router";
import { hasPmAccess } from "./access";
import { authClient } from "./auth-client";
import { createSessionCache } from "./session-cache";

const guardSession = createSessionCache(() => authClient.getSession());

/** Sign-out must call this, or the guards keep the old user for up to 30 seconds. */
export const forgetGuardSession = guardSession.clear;

export async function requireAuth() {
  const session = await guardSession.get();
  if (!session) throw redirect({ to: "/login" });
  return session;
}

export async function requireAdmin() {
  const session = await requireAuth();
  if (session.user.role !== "admin") throw redirect({ to: "/dashboard" });
  return session;
}

/** PM or admin; anyone else goes back to the dashboard. */
export async function requirePm() {
  const session = await requireAuth();
  if (!hasPmAccess(session)) throw redirect({ to: "/dashboard" });
  return session;
}
